var errorPresent = false;
$(document).on('ready turbolinks:load', function () {
  allInputs = document.querySelectorAll('.no-of-vendor, .spend-amount, .spend-amount-next-year-1, .spend-amount-next-year-2, .individual-no, .overall-no, #currency');
  allInputs.forEach(input => {
    input.addEventListener('input', window.parent.updateAllPercentages);
  });
  if (document.querySelector('.category-details')){
    window.parent.updateAllPercentages();
    window.parent.updateCertificateReadOnlyData();
    window.parent.attachEventOnSave();
  }
  console.log('from diversity procurement.js');
  verndorCountAndYear = document.querySelectorAll('#total-active-vendor, #calendar-year, #fiscal-year');
  verndorCountAndYear.forEach(input => {
    input.addEventListener('input', window.parent.updateCertificateReadOnlyData);
  });
});

function updateAllPercentages() {
  categoryDetailsArray = document.querySelectorAll('.category-details');
  totalAmountSpend = parseInt(document.querySelector('#total-spend').value);
  totalActiveVendor = parseInt(document.querySelector('#total-active-vendor').value);
  smallCategorySubTotalRow = document.querySelector('.small-category');
  diversityCategorySubTotalRow = document.querySelector('.diversity-category');
  certificateSubTotalRow = document.querySelector('.certificate-sub-total');
  invalidVendorCount = false;
  invalidAmount = false;

  currencyElement = document.getElementById("currency");
  selectedOption = currencyElement.options[currencyElement.selectedIndex];
  selectedCurrency = selectedOption.text;

  smallCategorySubTotal = { 
    'no_of_vendor': 0,
    'amount_spend': 0,
    'year_1': 0,
    'year_2': 0
  };
  diversityProcurementSubTotal = {
    'no_of_vendor': 0,
    'amount_spend': 0,
    'year_1': 0,
    'year_2': 0
  };
  categoryInputValueStorage = {};
  categoryDetailsArray.forEach(categoryDetails => {
    categoryId = categoryDetails.getAttribute('data-category-id');
    noOfVendorInput = categoryDetails.querySelector('.no-of-vendor');
    spendAmountInput = categoryDetails.querySelector('.spend-amount');
    spendAmountYearElement1 = categoryDetails.querySelector('.spend-amount-next-year-1');
    spendAmountYearElement2 = categoryDetails.querySelector('.spend-amount-next-year-2');
    vendorPercentageElement = categoryDetails.querySelector('.vendor-percentage');
    spendAmountPercentageElement = categoryDetails.querySelector('.spend-amount-percentage');
    subCategoryType = categoryDetails.getAttribute('data-category-type');

    noOfVendor = parseInt(noOfVendorInput.value);
    spendAmount = parseFloat(spendAmountInput.value);
    spendAmountYear1 = parseFloat(spendAmountYearElement1.value);
    spendAmountYear2 = parseFloat(spendAmountYearElement2.value);

    if (spendAmount > totalAmountSpend) {
      invalidAmount = true;
    }
    if (noOfVendor > totalActiveVendor) {
      invalidVendorCount = true;
    }

    if (subCategoryType == 'Small Business Category') {
      smallCategorySubTotal['no_of_vendor'] += noOfVendor;
      smallCategorySubTotal['amount_spend'] += spendAmount;
      smallCategorySubTotal['year_1'] += spendAmountYear1;
      smallCategorySubTotal['year_2'] += spendAmountYear2;
    } else if (subCategoryType == 'Diversity Category') {
      diversityProcurementSubTotal['no_of_vendor'] += noOfVendor;
      diversityProcurementSubTotal['amount_spend'] += spendAmount;
      diversityProcurementSubTotal['year_1'] += spendAmountYear1;
      diversityProcurementSubTotal['year_2'] += spendAmountYear2;
    }

    categoryInputValueStorage[categoryId] = noOfVendor;

    vendorPercentage = ((noOfVendor * 100)/totalActiveVendor).toFixed(2);

    spendAmountPercentage = ((spendAmount * 100)/totalAmountSpend).toFixed(2);
    if (isNaN(vendorPercentage)) {
      vendorPercentage = '-'
    } else {
      vendorPercentage = `${vendorPercentage}%`;
    } 

    if (isNaN(spendAmountPercentage)) {
      spendAmountPercentage = '-'
    } else {
      spendAmountPercentage = `${spendAmountPercentage}%`;
    } 
    vendorPercentageElement.textContent = vendorPercentage;
    spendAmountPercentageElement.textContent = spendAmountPercentage;
  });

  noOfVendor = parseInt(smallCategorySubTotal['no_of_vendor']);
  spendAmount = parseInt(smallCategorySubTotal['amount_spend']);

  subVendorPercentage = ((noOfVendor * 100)/totalActiveVendor).toFixed(2);
  subSpendAmountPercentage = ((spendAmount * 100)/totalAmountSpend).toFixed(2);

  smallCategorySubTotalRow.querySelector('.sub-no-of-vendor').textContent = formateNumber(smallCategorySubTotal['no_of_vendor'], false);
  smallCategorySubTotalRow.querySelector('.sub-vendor-percentage').textContent = formateNumber(subVendorPercentage, true);
  smallCategorySubTotalRow.querySelector('.sub-spend-amount').textContent = formateNumber(smallCategorySubTotal['amount_spend'], false);
  smallCategorySubTotalRow.querySelector('.sub-spend-amount-percentage').textContent = formateNumber(subSpendAmountPercentage, true);
  smallCategorySubTotalRow.querySelector('.sub-year-1').textContent = `${formateNumber(smallCategorySubTotal['year_1'], true)}`;
  smallCategorySubTotalRow.querySelector('.sub-year-2').textContent = `${formateNumber(smallCategorySubTotal['year_2'], true)}`;



  noOfVendor = parseInt(diversityProcurementSubTotal['no_of_vendor']);
  spendAmount = parseInt(diversityProcurementSubTotal['amount_spend']);

  subVendorPercentage = ((noOfVendor * 100)/totalActiveVendor).toFixed(2);
  subSpendAmountPercentage = ((spendAmount * 100)/totalAmountSpend).toFixed(2);

  diversityCategorySubTotalRow.querySelector('.sub-no-of-vendor').textContent = formateNumber(diversityProcurementSubTotal['no_of_vendor'], false);
  diversityCategorySubTotalRow.querySelector('.sub-vendor-percentage').textContent = formateNumber(subVendorPercentage, true);
  diversityCategorySubTotalRow.querySelector('.sub-spend-amount').textContent = formateNumber(diversityProcurementSubTotal['amount_spend'], false);
  diversityCategorySubTotalRow.querySelector('.sub-spend-amount-percentage').textContent = formateNumber(subSpendAmountPercentage, true);
  diversityCategorySubTotalRow.querySelector('.sub-year-1').textContent = `${formateNumber(diversityProcurementSubTotal['year_1'], true)}`;
  diversityCategorySubTotalRow.querySelector('.sub-year-2').textContent = `${formateNumber(diversityProcurementSubTotal['year_2'], true)}`;

  certificatesDetailsArray = document.querySelectorAll('.certificates-details');
  certificateSubTotal = { 
    'no_of_vendor': 0
  };
  invalidVendorCountForCertificate = false;
  certificatesDetailsArray.forEach(categoryDetails => {
    categoryId = categoryDetails.getAttribute('data-category-id');
    noOfVendorInput = categoryDetails.querySelector('.no-of-vendor');    
    vendorPercentageElement = categoryDetails.querySelector('.vendor-percentage');
    totalVendorForThisCategory = document.querySelector('.category-details ');
    noOfVendor = parseInt(noOfVendorInput.value); 
    userAddedValue = parseInt(categoryInputValueStorage[categoryId]);
    certificateSubTotal['no_of_vendor'] += noOfVendor;

    if (noOfVendor > userAddedValue){
      invalidVendorCountForCertificate = true;
    }
    vendorPercentage = ((noOfVendor * 100)/userAddedValue).toFixed(2);
    if (isNaN(vendorPercentage)) {
      vendorPercentage = '-'
    } else {
      vendorPercentage = `${vendorPercentage}%`;
    }

    vendorPercentageElement.textContent = vendorPercentage;
  });

  noOfVendor = parseInt(certificateSubTotal['no_of_vendor']);

  subVendorPercentage = ((noOfVendor * 100)/totalActiveVendor).toFixed(2);

  certificateSubTotalRow.querySelector('.sub-no-of-vendor').textContent = formateNumber(noOfVendor, false);
  certificateSubTotalRow.querySelector('.sub-vendor-percentage').textContent = formateNumber(subVendorPercentage, true);  

  rfxDetailsArray = document.querySelectorAll('.rfx-input-data');
  rfxSubTotalData = {};
  invalidCountForRfx = false;

  invalidRfxData = false;
  rfxDetailsArray.forEach(rfxDetails => {
    sourceTypeId = rfxDetails.getAttribute('data-source-type-id');
    totalElement = rfxDetails.querySelector('.overall-no'); 
    rowSubTotalElement = rfxDetails.querySelector('.row-total');    
    rowPercentageElement = rfxDetails.querySelector('.row-percentage');
    categoryInputData = rfxDetails.querySelectorAll('.category-input-data');
    rowTotal = parseInt(totalElement.value);
    rowSubTotal = 0;

    rfxSubTotalData['0'] = parseInt(rfxSubTotalData['0'] || 0) + rowTotal;

    categoryInputData.forEach(categoryInput => {
      individualElement = categoryInput.querySelector('.individual-no');
      individualNo = parseInt(individualElement.value || 0); 
      categoryId = individualElement.getAttribute('data-category-id');
      rowSubTotal += individualNo;
      if (individualNo > rowTotal || rowSubTotal > rowTotal){
        invalidRfxData = true;
      }

      rfxSubTotalData[categoryId] = parseInt(rfxSubTotalData[categoryId] || 0) + individualNo;
    });

    percentage = ((rowSubTotal * 100)/rowTotal).toFixed(2);
    rowSubTotalElement.textContent = formateNumber(rowSubTotal, false);
    rowPercentageElement.textContent = formateNumber(percentage, true);
  });

  subTotalRow = document.querySelector('.sub-total-row');
  subTotalRow.querySelector('.overall-no').textContent = formateNumber(rfxSubTotalData['0']);
  subTotalRowCount = 0;
  subTotalRow.querySelectorAll('.individual-no').forEach( element => {
    element.textContent = formateNumber(parseInt(rfxSubTotalData[element.getAttribute('data-category-id')]), false);
    subTotalRowCount += parseInt(rfxSubTotalData[element.getAttribute('data-category-id')]);
  });
  subTotalRow.querySelector('.row-total').textContent = subTotalRowCount;
  subTotalRow.querySelector('.row-percentage').textContent = subTotalRowCount + subTotalRowCount;

  if (invalidVendorCount) {
    alert("Vendor no can not be greater then total active vendor.");
    errorPresent = true;
  }
  if (invalidAmount) {
    alert("Amount can not be greater then total spend amount.");
    errorPresent = true;
  }
  if (invalidVendorCountForCertificate) {
    alert("Cerfificate vendor count can not be greater then it's input value from above tables.");
    errorPresent = true;
  }
  if (invalidRfxData) {
    alert("RFX data count can not be greater then it's total input value");
    errorPresent = true;
  }
  if (formateNumber(smallCategorySubTotal['no_of_vendor'], false) > totalActiveVendor || formateNumber(diversityProcurementSubTotal['no_of_vendor'], false) > totalActiveVendor){
    alert("Sub total can not be greater then total active vendor.");
    errorPresent = true;
  }
  if (formateNumber(smallCategorySubTotal['amount_spend'], false) > totalAmountSpend || formateNumber(diversityProcurementSubTotal['amount_spend'], false) > totalAmountSpend){
    alert("Sub total amount can not be greater then total spend amount.");
    errorPresent = true;
  }
}

function attachEventOnSave() { 
  categoryDetails = document.querySelectorAll('.category-details');
  userId = document.querySelector('#user-id').value;
  certificatesDetailsArray = document.querySelectorAll('.certificates-details');
  rfxDetailsArray = document.querySelectorAll('.rfx-input-data');
  saveButton = document.getElementById('saveButton');
  if (saveButton) {
    saveButton.addEventListener('click', function () {
      saveButton.style.pointerEvents = 'none';
      collectedData = {};
      cetegoryDetails = [];
      certificateDetails = [];
      rfxData = [];

      pageType = document.getElementById('saveButton').getAttribute('data-page-type');
      totalAmountSpend = parseInt(document.querySelector('#total-spend').value);
      totalActiveVendor = parseInt(document.querySelector('#total-active-vendor').value);
      currency = document.querySelector('#currency').value;
      calendarYear = document.querySelector('#calendar-year').value;
      fiscalYear = document.querySelector('#fiscal-year').value;
      startMonth = document.querySelector('#start-month').value;
      endMonth = document.querySelector('#end-month').value;
      diversityProcurementid = document.querySelector('#diversity-procurement-id').value;
      targetYear1 = document.querySelector('.header-row #target-year-1').value;
      targetYear2 = document.querySelector('.header-row #target-year-2').value;


      categoryDetails.forEach(function (category) {
        recordId = category.getAttribute('data-value-id');
        category_id = category.getAttribute('data-category-id');
        noOfVendor = category.querySelector('.no-of-vendor').value;
        spendAmount = category.querySelector('.spend-amount').value;
        spendAmountNextYear1 = category.querySelector('[name="target_spend[1]"]').value;
        spendAmountNextYear2 = category.querySelector('[name="target_spend[2]"]').value;

        categoryData = {
          record_id: recordId,
          diversity_procurement_category_id: category_id,
          no_of_vendor: noOfVendor,
          spend_amount: spendAmount,
          target_spend_1: spendAmountNextYear1,
          target_spend_2: spendAmountNextYear2 
        };

        cetegoryDetails.push(categoryData);
      });

      certificatesDetailsArray.forEach(function (category) {
        recordId = category.getAttribute('data-value-id');
        category_id = category.getAttribute('data-category-id');
        noOfVendor = category.querySelector('.no-of-vendor').value;

        certificateData = {
          record_id: recordId,
          diversity_procurement_category_id: category_id,
          no_of_vendor: noOfVendor
        };

        certificateDetails.push(certificateData);
      });

      rfxDetailsArray.forEach(function (business_type) {
        source_type_id = business_type.getAttribute('data-source-type-id');
        overall_value = parseInt(business_type.querySelector('.overall-no'));
        allInputs = business_type.querySelectorAll('.individual-no');
        allInputs.forEach(function (input_column) {
          rfx_category_id = input_column.getAttribute('data-category-id');
          recordId = input_column.getAttribute('data-record-id');
          value = input_column.value;
          if (value > overall_value ){

          }
          data = {
            record_id: recordId,
            rfx_category_id: rfx_category_id,
            rfx_detail_id: source_type_id,
            value: value
          }
          rfxData.push(data);
        });
      });

      collectedData = {
        cetegory_details: cetegoryDetails,
        certificate_details: certificateDetails,
        total_active_vendor: totalActiveVendor,
        total_spend: totalAmountSpend,
        currency_id: currency,
        calendar_year: calendarYear,
        fiscal_year: fiscalYear,
        start_month: startMonth,
        end_month: endMonth,
        user_id: userId,
        target_year_1: targetYear1,
        target_year_2: targetYear2,
        rfxDetails: rfxData
      }

      console.log(collectedData);
      errorPresent = false;
      if (errorPresent) {
        alert("Invalid Number");
      }
      else {
        if (pageType == 'new') {
          url = '/diversity_procurements'
          method_type = 'POST'
        }
        else if (pageType == 'edit'){
          url = `/diversity_procurements/${diversityProcurementid}`
          method_type = 'PUT'
        } 
        
        fetch(url, {
          method: method_type,
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify(collectedData),
        })
          .then((response) => response.json())
          .then((data) => {
            if (data.success) {
              alert("Data saved successfully.");
              window.location.href = data.redirect_url;
            } else {
              alert("Invalid data !");
              console.error("Error:", data.error);
            }
          })
          .catch((error) => {
            alert("Invalid data !");
            console.error("Error:", error);
          });
      }
    });
  }
}

function formateNumber(number, percentage){
  if (!isNaN(number)) {
    if (percentage)
      return `${number}%`;
    else {
      return number
    }
  } else {
    return '-';
  }
}

function updateCertificateReadOnlyData(){
  activeVendorCount = document.getElementById("total-active-vendor");
  calendarYear = document.getElementById("calendar-year");
  fiscalYear = document.getElementById("fiscal-year");

  activeVendorCountReadOnly = document.querySelectorAll(".certificate-total-active-vendor");
  calendarYearReadOnly = document.querySelectorAll(".certificate-calendar-year");
  fiscalYearReadOnly = document.querySelectorAll(".certificate-fiscal-year");

  activeVendorCountReadOnly.forEach(element => {
    element.textContent = activeVendorCount.value;
  });

  calendarYearReadOnly.forEach(element => {
    element.textContent = calendarYear.value;
  });

  fiscalYearReadOnly.forEach(element => {
    element.textContent = `${fiscalYear.value}`;
  });

  currencyElement = document.getElementById("currency");
  selectedOption = currencyElement.options[currencyElement.selectedIndex];
  selectedCurrency = selectedOption.text;
  all_currency_elements = document.querySelectorAll(".currency");
  all_currency_elements.forEach(element => {
    element.textContent = selectedCurrency;
  });
}

window.parent.updateAllPercentages = updateAllPercentages;
window.parent.attachEventOnSave = attachEventOnSave;
window.parent.updateCertificateReadOnlyData = updateCertificateReadOnlyData;